import React from "react";

export function Field({ label, hint, children, required }) {
  return (
    <div className="space-y-2">
      <label className="block">
        <span className="rcw-label">
          {label}
          {required ? <span className="text-amber-500 ml-1">*</span> : null}
        </span>
        {hint ? <span className="block text-xs text-gray-500 mt-1">{hint}</span> : null}
      </label>
      {children}
    </div>
  );
}

export function Input(props) {
  return <input className="rcw-input" {...props} />;
}

export function Textarea(props) {
  return <textarea className="rcw-textarea" {...props} />;
}

export function Select({ options = [], ...props }) {
  return (
    <select className="rcw-input" {...props}>
      <option value="">— Select —</option>
      {options.map((o) => (
        <option key={o} value={o}>
          {o}
        </option>
      ))}
    </select>
  );
}

export function SectionTitle({ children, eyebrow, hint }) {
  return (
    <div className="mb-6">
      {eyebrow ? <div className="rcw-label mb-2">{eyebrow}</div> : null}
      <h2 className="font-display text-2xl sm:text-3xl font-semibold text-gray-900 tracking-tight">
        {children}
      </h2>
      {hint ? <p className="mt-2 text-sm text-gray-500 max-w-prose">{hint}</p> : null}
    </div>
  );
}
